import React from 'react';
import { Account } from './icons/Account';
import { AccountFlag } from './icons/AccountFlag';
import { AgentBooking } from './icons/AgentBooking';
import { Alert } from './icons/Alert';
import { AlertCircle } from './icons/AlertCircle';
import { AlertOutline } from './icons/AlertOutline';
import { AlertTriangle } from './icons/AlertTriangle';
import { Application } from './icons/Application';
import { ApplicationComplete } from './icons/ApplicationComplete';
import { ArrowDown } from './icons/ArrowDown';
import { ArrowDownRight } from './icons/ArrowDownright';
import { ArrowLeft } from './icons/ArrowLeft';
import { ArrowRight } from './icons/ArrowRight';
import { ArrowUp } from './icons/ArrowUp';
import { Asterisk } from './icons/Asterisk';
import { Attendees } from './icons/Attendees';
import { Barcode } from './icons/Barcode';
import { Booking } from './icons/Booking';
import { Building } from './icons/Building';
import { Bullet } from './icons/Bullet';
import { Calendar } from './icons/Calendar';
import { Camera } from './icons/Camera';
import { Cancelled } from './icons/Cancelled';
import { CaretDown } from './icons/CaretDown';
import { CaretLeft } from './icons/CaretLeft';
import { CaretRight } from './icons/CaretRight';
import { CaretUp } from './icons/CaretUp';
import { ChartGantt } from './icons/ChartGantt';
import { ChartReport } from './icons/ChartReport';
import { Checkbox } from './icons/Checkbox';
import { CheckboxUnselected } from './icons/CheckboxUnselected';
import { CheckIn } from './icons/CheckIn';
import { CheckOut } from './icons/CheckOut';
import { ChevronDown } from './icons/ChevronDown';
import { ChevronDownSmall } from './icons/ChevronDownSmall';
import { ChevronLeft } from './icons/ChevronLeft';
import { ChevronLeftSmall } from './icons/ChevronLeftSmall';
import { ChevronRight } from './icons/ChevronRight';
import { ChevronRightSmall } from './icons/ChevronRightSmall';
import { ChevronRightThin } from './icons/ChevronRightThin';
import { ChevronStepLeft } from './icons/ChevronStepLeft';
import { ChevronStepRight } from './icons/ChevronStepRight';
import { ChevronUp } from './icons/ChevronUp';
import { ChevronUpSmall } from './icons/ChevronUpSmall';
import { ChevronUpThin } from './icons/ChevronUpThin';
import { ClearFilters } from './icons/ClearFilters';
import { Clock } from './icons/Clock';
import { CloseCircle } from './icons/CloseCircle';
import { CloseSmall } from './icons/CloseSmall';
import { CloseThick } from './icons/CloseThick';
import { CloseThin } from './icons/CloseThin';
import { Column } from './icons/Column';
import { Connect } from './icons/Connect';
import { Connection } from './icons/Connection';
import { Designer } from './icons/Designer';
import { Drag } from './icons/DragIcon';
import { Edit } from './icons/Edit';
import { EllipsesHorizontal } from './icons/EllipsesHorizontal';
import { EllipsesVertical } from './icons/EllipsesVertical';
import { Export } from './icons/Export';
import { Filter } from './icons/Filter';
import { FiltersAdvancedV2 } from './icons/FiltersAdvancedV2';
import { FiltersV2 } from './icons/FiltersV2';
import { Folder } from './icons/Folder';
import { Import } from './icons/Import';
import { IncidentHoldFlag } from './icons/IncidentHoldFlag';
import { InformationCircle } from './icons/InformationCircle';
import { List } from './icons/List';
import { Mail } from './icons/Mail';
import { MedicalFlag } from './icons/MedicalFlag';
import { NoteAdd } from './icons/NoteAdd';
import { NotesFlag } from './icons/NotesFlag';
import { PaperClip } from './icons/PaperClip';
import { Plus } from './icons/Plus';
import { Print } from './icons/Print';
import { PrivacyFlag } from './icons/PrivacyFlag';
import { Refresh } from './icons/Refresh';
import { Rez360 } from './icons/Rez360';
import { Save } from './icons/Save';
import { Search } from './icons/Search';
import { ShieldNegativeFlag } from './icons/ShieldNegativeFlag';
import { ShieldPositiveFlag } from './icons/ShieldPositiveFlag';
import { SortAsc } from './icons/SortAsc';
import { SortDesc } from './icons/SortDesc';
import { StarFilled } from './icons/StarFilled';
import { StarOutline } from './icons/StarOutline';
import { Tick } from './icons/Tick';
import { TickCircle } from './icons/TickCircle';
import { User } from './icons/User';
import { Variable } from './icons/Variable';

interface IIconProps extends image.IStarryUIIcon {
    variant: image.IconVariants;
}

export const Icon = ({ variant, ...props }: IIconProps) => {
    return (
        <>
            {variant === 'Account' && <Account {...props} />}
            {variant === 'AccountFlag' && <AccountFlag {...props} />}
            {variant === 'AgentBooking' && <AgentBooking {...props} />}
            {variant === 'Alert' && <Alert {...props} />}
            {variant === 'AlertCircle' && <AlertCircle {...props} />}
            {variant === 'AlertOutline' && <AlertOutline {...props} />}
            {variant === 'AlertTriangle' && <AlertTriangle {...props} />}
            {variant === 'AlertTriangle' && <AlertTriangle {...props} />}
            {variant === 'Application' && <Application {...props} />}
            {variant === 'Application' && <Application {...props} />}
            {variant === 'ApplicationComplete' && <ApplicationComplete {...props} />}
            {variant === 'ArrowDown' && <ArrowDown {...props} />}
            {variant === 'ArrowDownRight' && <ArrowDownRight {...props} />}
            {variant === 'ArrowLeft' && <ArrowLeft {...props} />}
            {variant === 'ArrowRight' && <ArrowRight {...props} />}
            {variant === 'ArrowUp' && <ArrowUp {...props} />}
            {variant === 'Asterisk' && <Asterisk {...props} />}
            {variant === 'Attendees' && <Attendees {...props} />}
            {variant === 'Barcode' && <Barcode {...props} />}
            {variant === 'Booking' && <Booking {...props} />}
            {variant === 'Building' && <Building {...props} />}
            {variant === 'Bullet' && <Bullet {...props} />}
            {variant === 'Calendar' && <Calendar {...props} />}
            {variant === 'Camera' && <Camera {...props} />}
            {variant === 'Cancelled' && <Cancelled {...props} />}
            {variant === 'CaretDown' && <CaretDown {...props} />}
            {variant === 'CaretLeft' && <CaretLeft {...props} />}
            {variant === 'CaretRight' && <CaretRight {...props} />}
            {variant === 'CaretUp' && <CaretUp {...props} />}
            {variant === 'ChartGantt' && <ChartGantt {...props} />}
            {variant === 'ChartReport' && <ChartReport {...props} />}
            {variant === 'Checkbox' && <Checkbox {...props} />}
            {variant === 'CheckboxUnselected' && <CheckboxUnselected {...props} />}
            {variant === 'CheckIn' && <CheckIn {...props} />}
            {variant === 'CheckOut' && <CheckOut {...props} />}
            {variant === 'ChevronDown' && <ChevronDown {...props} />}
            {variant === 'ChevronDownSmall' && <ChevronDownSmall {...props} />}
            {variant === 'ChevronLeft' && <ChevronLeft {...props} />}
            {variant === 'ChevronLeftSmall' && <ChevronLeftSmall {...props} />}
            {variant === 'ChevronRight' && <ChevronRight {...props} />}
            {variant === 'ChevronRightSmall' && <ChevronRightSmall {...props} />}
            {variant === 'ChevronRightThin' && <ChevronRightThin {...props} />}
            {variant === 'ChevronStepLeft' && <ChevronStepLeft {...props} />}
            {variant === 'ChevronStepRight' && <ChevronStepRight {...props} />}
            {variant === 'ChevronUp' && <ChevronUp {...props} />}
            {variant === 'ChevronUpSmall' && <ChevronUpSmall {...props} />}
            {variant === 'ChevronUpThin' && <ChevronUpThin {...props} />}
            {variant === 'ClearFilters' && <ClearFilters {...props} />}
            {variant === 'Clock' && <Clock {...props} />}
            {variant === 'CloseCircle' && <CloseCircle {...props} />}
            {variant === 'CloseSmall' && <CloseSmall {...props} />}
            {variant === 'CloseThick' && <CloseThick {...props} />}
            {variant === 'CloseThin' && <CloseThin {...props} />}
            {variant === 'Column' && <Column {...props} />}
            {variant === 'Connect' && <Connect {...props} />}
            {variant === 'Connection' && <Connection {...props} />}
            {variant === 'Designer' && <Designer {...props} />}
            {variant === 'Drag' && <Drag {...props} />}
            {variant === 'Edit' && <Edit {...props} />}
            {variant === 'EllipsesHorizontal' && <EllipsesHorizontal {...props} />}
            {variant === 'EllipsesVertical' && <EllipsesVertical {...props} />}
            {variant === 'Export' && <Export {...props} />}
            {variant === 'Filter' && <Filter {...props} />}
            {variant === 'FiltersAdvancedV2' && <FiltersAdvancedV2 {...props} />}
            {variant === 'FiltersV2' && <FiltersV2 {...props} />}
            {variant === 'Folder' && <Folder {...props} />}
            {variant === 'Import' && <Import {...props} />}
            {variant === 'IncidentHoldFlag' && <IncidentHoldFlag {...props} />}
            {variant === 'InformationCircle' && <InformationCircle {...props} />}
            {variant === 'List' && <List {...props} />}
            {variant === 'Mail' && <Mail {...props} />}
            {variant === 'MedicalFlag' && <MedicalFlag {...props} />}
            {variant === 'NoteAdd' && <NoteAdd {...props} />}
            {variant === 'NotesFlag' && <NotesFlag {...props} />}
            {variant === 'PaperClip' && <PaperClip {...props} />}
            {variant === 'Plus' && <Plus {...props} />}
            {variant === 'Print' && <Print {...props} />}
            {variant === 'PrivacyFlag' && <PrivacyFlag {...props} />}
            {variant === 'Refresh' && <Refresh {...props} />}
            {variant === 'Rez360' && <Rez360 {...props} />}
            {variant === 'Save' && <Save {...props} />}
            {variant === 'Search' && <Search {...props} />}
            {variant === 'ShieldNegativeFlag' && <ShieldNegativeFlag {...props} />}
            {variant === 'ShieldPositiveFlag' && <ShieldPositiveFlag {...props} />}
            {variant === 'SortAsc' && <SortAsc {...props} />}
            {variant === 'SortDesc' && <SortDesc {...props} />}
            {variant === 'StarFilled' && <StarFilled {...props} />}
            {variant === 'StarOutline' && <StarOutline {...props} />}
            {variant === 'Tick' && <Tick {...props} />}
            {variant === 'TickCircle' && <TickCircle {...props} />}
            {variant === 'User' && <User {...props} />}
            {variant === 'Variable' && <Variable {...props} />}
        </>
    );
};
